module.exports = __webpack_public_path__ + "assets/media/default-avatar.8ddc009e.svg";